export default __webpack_public_path__ + "static/media/CREDIT_MATT_GRACE_PRIME_VIDEO_00338_R5_1.c1baf927.jpg";